import type * as pf from '@amirada/lib-shared'
import { PfCmdType } from '@amirada/lib-shared'

import type * as tp from '@base/utils/types'
import { ut_capStore, ut_createParamDataString } from '@base/utils/utils'
import { usePfinderAPI } from '@base/composables/pfinderAPI'

export const useDetailStore = defineStore('detailStore', () => {
  const state: { [key: string]: pf.TPfNode } = reactive({})
  const pfinderAPI = usePfinderAPI()

  function cacheKey(paramData: tp.IParamData): string {
    return [ut_createParamDataString(paramData),
      paramData.namePath].join('#')
  }

  // The path comes from paramData, like everywhere else: it is what the cache key is built from, so
  // taking it as a second argument only ever allowed the request and the entry it lands in to
  // describe different nodes. isConfig stays — the split cannot be derived from the path alone.
  async function callDetailData(paramData: tp.IParamData, isConfig: boolean): Promise<pf.TPfNode | undefined> {
    const detailData = getDetailData(paramData)
    if (!detailData) {
      const paths: string[] = paramData.namePath.split('/')
      let conf: string
      let nodeName: string = ''
      if (isConfig) {
        conf = paths[paths.length - 1] || ''
      }
      else {
        conf = paths[paths.length - 2] || ''
        nodeName = paths[paths.length - 1] || ''
      }
      const args: pf.PfCmd<PfCmdType.DETAIL>['arg'] = {
        conf,
        nodeName,
      }
      const data: tp.IFetchData = {
        paramData,
      }
      const res = await pfinderAPI.fetchData(PfCmdType.DETAIL, args, data)

      if (res && res.result) {
        setDetailData(paramData, res.result)
      }
      return getDetailData(paramData)
    }
    else {
      return detailData
    }
  }

  function setDetailData(paramData: tp.IParamData, data: pf.TPfNode): void {
    ut_capStore(state)
    state[cacheKey(paramData)] = data
  }

  function getDetailData(paramData: tp.IParamData): pf.TPfNode | undefined {
    return state[cacheKey(paramData)]
  }

  return {
    state,
    callDetailData,
    getDetailData,
    setDetailData,
  }
})
